import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import { DataContext } from "./DataContext";
import Loader from "../../components/common/Loader";
import { fetchRecordByKey } from "../../services/IndexedDBUtil";
import { DATABASE_NAME, STORE_NAME } from "../../services/constants";
import { FixedSizeList as List } from "react-window";
import { useFormContext } from './FormContext';
import { filterSelectedItems } from './helper'


const Stage3CheckboxList = ({
  selectedItems,
  setSelectedItems,
  heirarchyHeaderName,
  searchString,
  selectedTreeNode,
  zone,
}) => {
  //  format of items
  //     { id: 1_1_12, ...level3 },

  const [choosenItems, setChoosenItems] = useState([]);
  const [choosenSearchItems, setChoosenSearchItems] = useState([]);

  const [totalChoosen, setTotalChoosen] = useState(0);
  const [totalSelected, setTotalSelected] = useState(0);

  const [isLoading, setIsLoading] = useState(true);

  const { geography, products } = useContext(DataContext);
  const { formData, updateFormData } = useFormContext();


  const [level6Data, setLevel6Data] = useState(null);

  useEffect(() => {
    const init = async () => {
      if (zone.zoneId == 1) {
        let _items = [];
        const result = await fetchRecordByKey(DATABASE_NAME, STORE_NAME, "SKUS");
        if (result.success) {
          setIsLoading(true);
          _items = result.record.data;
          setIsLoading(false);
          setLevel6Data(_items);
        }
      }
    }
    init();
  }, []);


 
  async function GetMasterListOfItems() {
    if (zone.zoneId == 1) {
      // let _items = [];
      // const result = await fetchRecordByKey(DATABASE_NAME, STORE_NAME, "SKUS");
      // if (result.success) {
      //   setIsLoading(true);
      //   _items = result.record.data;
      //   setIsLoading(false);

      // } else  if (zone.zoneId == 2){
      //   console.error("Failed to fetch record:", result.message);
      //   if (result.error) {
      //     console.error("Error details:", result.error);
      //   }
      // }
      // return _items;

      return await products;
    } else if (zone.zoneId == 2) {
      return await geography;
    }
  }

  useEffect(() => {
    const init = async () => {
      setIsLoading(true);
      let masterlist = await GetMasterListOfItems();  
      filterItemsOnSelectedTreeNode(masterlist);
      setIsLoading(false);
    }
    init();
  }, [selectedTreeNode]);



  async function filterItemsOnSelectedTreeNode(masterList) {

    if (selectedTreeNode !== null) {
      let filteredItems;

      switch (selectedTreeNode.level) {
        case "level1":
          filteredItems = masterList?.data?.level2?.filter(elem => elem.level1_id == selectedTreeNode.level1_id);
          break;

        case "level2":
          filteredItems = masterList?.data?.level3?.filter(
            (elem) =>
              elem.level1_id == selectedTreeNode.level1_id &&
              elem.level2_id == selectedTreeNode.level2_id
          );
          break;

        case "level3":
          filteredItems = masterList?.data?.level4?.filter(
            (elem) =>
              elem.level1_id == selectedTreeNode.level1_id &&
              elem.level2_id == selectedTreeNode.level2_id &&
              elem.level3_id == selectedTreeNode.level3_id
          );
          break;

        case "level4":
          filteredItems = masterList?.data?.level5?.filter(
            (elem) =>
              elem.level1_id == selectedTreeNode.level1_id &&
              elem.level2_id == selectedTreeNode.level2_id &&
              elem.level3_id == selectedTreeNode.level3_id &&
              elem.level4_id == selectedTreeNode.level4_id
          );
          break;

        case "level5":
          filteredItems = level6Data?.filter(
            (elem) =>
              elem.level1_id == selectedTreeNode.level1_id &&
              elem.level2_id == selectedTreeNode.level2_id &&
              elem.level3_id == selectedTreeNode.level3_id &&
              elem.level4_id == selectedTreeNode.level4_id &&
              elem.level5_id == selectedTreeNode.level5_id
          );
          break;

        default:
          filteredItems = [];
      }
      const sortedItems = filteredItems;//.sort((a, b) => a.name.localeCompare(b.name));
      // const sortedItems = filteredItems.sort((a, b) => a.name.localeCompare(b.name));
      setChoosenItems(sortedItems);
      setChoosenSearchItems(sortedItems); // to show search results immediately when search is initiated
    }
  }



  useEffect(() => {
    if (searchString.trim() === "") {
      // Show all items of selectedNode
      // if (zone.zoneId == 1) {
      //   filterSkusOnSelectedTreeNode();
      // } else if (zone.zoneId == 2) {
      //   filterGeosOnSelectedTreeNode();
      // }
      let masterlist = GetMasterListOfItems();
      filterItemsOnSelectedTreeNode(masterlist);
    } else {
      // Filter items based on searchString
      const lowercasedSearch = searchString.toLowerCase();
      const filtered = choosenSearchItems.filter((item) =>
        item.name.toLowerCase().includes(lowercasedSearch)
      )
      //.sort((a, b) => a.name.localeCompare(b.name));

      //setChoosenItems(filtered.sort((a, b) => a.name.localeCompare(b.name)));
      setChoosenItems(filtered);
    }
  }, [searchString]);

  useEffect(() => {
    setTotalChoosen(choosenItems?.length);
    let _items = choosenItems.filter(element => selectedItems.map(item => item.id).includes(element.id))
    setTotalSelected(_items?.length);
  });

  // Function to toggle individual checkbox
  const handleCheckboxChange = (e) => {

    if (zone.zoneId == 1) {
      try {
        let { dataset, id, checked } = e.target;
        if (checked) {
          const exists = selectedItems?.some((el) => el.id == id);
          if (!exists) {
            const newItem = { id: id, breadcrumb: dataset.breadcrumb };
            setSelectedItems((prevSelectedItem) => {
              const updatedItems = [...prevSelectedItem, newItem];
              // update_form_data('products', updatedItems);
              // return updatedItems;
              //const _filteredItems = filterSelectedItems(updatedItems, { id });
              update_form_data('products', updatedItems);
              return updatedItems;
            })
          }
        } else {
          setSelectedItems((prevSelectedItems) => {
            const updatedItems = prevSelectedItems.filter((item) => item.id !== id);
            update_form_data('products', updatedItems);
            return updatedItems;
          })
        }
      } catch (error) {
        console.log(error);
      }
    }
    else if (zone.zoneId == 2) {
      try {
        let { dataset, id, checked } = e.target;
        if (checked) {

          const exists = selectedItems?.some((el) => el.id == id);
          if (!exists) {
            const newItem = { id: id, breadcrumb: dataset.breadcrumb };
            setSelectedItems((prevSelectedItem) => {
              const updatedItems = [...prevSelectedItem, newItem];
              const _filteredItems = filterSelectedItems(updatedItems, { id });
              update_form_data('geography', _filteredItems);
              return _filteredItems;
            })
          }
        } else {
          setSelectedItems((prevSelectedItems) => {
            const updatedItems = prevSelectedItems.filter((item) => item.id !== id);
            update_form_data('geography', updatedItems);
            return updatedItems;
          })
        }
      } catch (error) {
        console.log(error);
      }
    }
  };


  function update_form_data(key, value) {
    updateFormData('stage3', {
      ...formData.stage3,
      [key]: value
    })
  }

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      if (zone.zoneId == 1) {
        setSelectedItems((prevSelectedItems) => {
          // Append unique items from choosenItems to existing selectedItems
          //prevSelectedItems = filterSelectedItems(prevSelectedItems, choosenItems.map(el => ({ id: el.id }))); //newly added
          const updatedItems = [
            ...prevSelectedItems,
            ...choosenItems.filter(el =>
              !prevSelectedItems.some(selected => selected.id === el.id)
            ).map(el => ({ id: el.id, breadcrumb: el.breadcrumb }))
          ];
          update_form_array('products', updatedItems);
          return updatedItems;
        });
      } else if (zone.zoneId == 2) {
        setSelectedItems((prevSelectedItems) => {
          // Append unique items from choosenItems to existing selectedItems
          prevSelectedItems = filterSelectedItems(prevSelectedItems, choosenItems.map(el => ({ id: el.id })));
          const updatedItems = [
            ...prevSelectedItems,
            ...choosenItems.filter(el =>
              !prevSelectedItems.some(selected => selected.id === el.id)
            ).map(el => ({ id: el.id, breadcrumb: el.breadcrumb }))
          ];
          update_form_array('geography', updatedItems);
          return updatedItems;
        });
      }
    } else {
      if (zone.zoneId == 1) {
        // Remove choosenItems from selectedItems
        setSelectedItems((prevSelectedItems) => {
          const updatedItems = prevSelectedItems.filter(
            selected => !choosenItems.some(el => el.id === selected.id)
          );
          update_form_array('products', updatedItems);
          return updatedItems;
        });
      } else if (zone.zoneId == 2) {
        // Remove choosenItems from selectedItems
        setSelectedItems((prevSelectedItems) => {
          const updatedItems = prevSelectedItems.filter(
            selected => !choosenItems.some(el => el.id === selected.id)
          );
          update_form_array('geography', updatedItems);
          return updatedItems;
        });
      }
    }
  };

  function update_form_array(key, value) {
    updateFormData("stage3", {
      ...formData.stage3,
      [key]: value, // Directly set the value with the updated array
    });
  }


  return (
    <Wrapper>
      {isLoading ? (
        <Loader size={"large"} />
      ) : (
        <div
          className="checkbox"
          style={{ display: choosenItems?.length ? "block" : "none" }}
        >
          <input
            id="selectAllItem"
            type="checkbox"
            checked={choosenItems.every(element => selectedItems.map(item => item.id).includes(element.id))}
            onChange={handleSelectAllChange}
          />
          <label htmlFor="selectAllItem">
            Select All <span> {`(${totalSelected}/${totalChoosen})`} </span>{" "}
          </label>
        </div>
      )}
      {!choosenItems.length ? (
        <span>
          No Records found for selected{" "}
          {heirarchyHeaderName.substring(0, heirarchyHeaderName.length - 1)}
        </span>
      ) : (
        <></>
      )}
      <VirtualizedCheckboxList
        items={choosenItems}
        selectedItems={selectedItems}
        onItemSelect={handleCheckboxChange}
      />
    </Wrapper>
  );
};

const VirtualizedCheckboxList = ({ items, selectedItems, onItemSelect }) => {
  // Height for each row
  const ITEM_HEIGHT = 40;
  // Maximum height for the list container
  const LIST_HEIGHT = 400;

  // Render each row
  const Row = React.memo(({ index, isScrolling, style }) => {
    const item = items[index];
    const isSelected = selectedItems?.some((el) => el.id === item.id);

    return (
      <>
        {
          <div
            style={{
              ...style,
              display: "flex",
              alignItems: "center",
              padding: "0 16px",
            }}
          >
            <div className="checkbox cursor-pointer">
              <input
                id={item.id}
                type="checkbox"
                data-breadcrumb={item.breadcrumb}
                checked={isSelected}
                onChange={onItemSelect}
                className="mr-2 "
              />
              <label
                htmlFor={item.id}
                className="ml-2 select-none cursor-pointer"
              >
                {item.name}
              </label>
            </div>
          </div>
        }
      </>
    );
  });
  return (
    <List
      useIsScrolling
      height={465}
      itemCount={items.length}
      itemSize={ITEM_HEIGHT}
       
      className="custom-scrollbar"
    >
      {Row}
    </List>
  );

}
export default Stage3CheckboxList;



const Wrapper = styled.div`
  float: left;
  width: 100%;
  padding: 0px 23px;
  z-index: 9;
  position: relative;

  .checkbox label {
    min-height: 20px;
    padding-left: 7px;
    margin-bottom: 0;
    font-weight: 400;
    cursor: pointer;
  }

  .custom-scrollbar{
    left: -16px;
    top: -10px;
    margin-left: -20px;
    margin-right: -53px !important;
    div {
      div {
        padding: 0px 20px;
      }
    }
  }
`;
